import React from "react";
import { Row, Col, Badge } from "react-bootstrap";
import { CommonSelect, CommonInput } from "../../Input";

const Step2BulkPaymentInfo = ({ selectedReceivers, onRemoveReceiver }) => {
  return (
    <div className="mt-2">
      <Row className="mb-4 g-3 align-items-end">
        <Col md={3}>
          <label className="text-muted fs-11 mb-2 d-block">Send Currency</label>
          <CommonSelect
            placeholder="Singapore Dollar"
            options={[{ value: "SGD", label: "Singapore Dollar" }]}
          />
        </Col>
        <Col md={3}>
          <label className="text-muted fs-11 mb-2 d-block">Source of Funds</label>
          <CommonSelect
            placeholder="Select source of funds"
            options={[{ value: "savings", label: "Savings" }]}
          />
        </Col>
        <Col md={6}>
          <label className="text-muted fs-11 mb-2 d-block">Transaction Reference</label>
          <CommonInput placeholder="Enter transaction reference" />
        </Col>
      </Row>

      <div className="d-flex flex-column gap-3">
        {selectedReceivers.map((receiver) => (
          <div
            key={receiver.id}
            className="card border-0 shadow-sm rounded-4 mb-0 bg-white"
            style={{ border: "1px solid #f0f0f0" }}
          >
            <div className="card-body p-3 d-flex align-items-center gap-3">
              <div
                className="bg-light-gray-soft rounded-3 d-flex align-items-center justify-content-center p-3"
                style={{ minWidth: "160px", height: "80px" }}
              >
                <span className="fw-bold text-black fs-14">{receiver.name}</span>
              </div>

              <div className="flex-grow-1">
                <Row className="g-2 g-xl-3 align-items-start">
                  <Col xl={3} md={6}>
                    <div className="mb-1">
                      <label className="text-muted fs-11 mb-1 d-block font-w500">
                        Send Amount
                      </label>
                      <div className="input-group">
                        <span className="input-group-text bg-light border-end-0 fs-12 text-muted px-2">
                          SGD
                        </span>
                        <input
                          type="text"
                          className="form-control border-start-0 fs-13 py-2"
                          defaultValue="1"
                        />
                      </div>
                      <span className="text-muted fs-10 d-block mt-1">
                        1 SGD = 3.4225 MYR
                      </span>
                    </div>
                  </Col>
                  <Col xl={3} md={6}>
                    <div>
                      <label className="text-muted fs-11 mb-1 d-block font-w500">
                        Receiving Amount
                      </label>
                      <div className="input-group">
                        <span className="input-group-text bg-light border-end-0 fs-12 text-muted px-2">
                          MYR
                        </span>
                        <input
                          type="text"
                          className="form-control border-start-0 fs-13 py-2"
                          value="3.4225"
                          readOnly
                        />
                      </div>
                    </div>
                  </Col>
                  <Col xl={2} md={6}>
                    <div>
                      <label className="text-muted fs-11 mb-1 d-block font-w500">
                        Fee
                      </label>
                      <input
                        type="text"
                        className="form-control fs-13 py-2"
                        value="0"
                        readOnly
                      />
                    </div>
                  </Col>
                  <Col xl={4} md={6}>
                    <div>
                      <label className="text-muted fs-11 mb-1 d-block font-w500">
                        Purpose of Transfer
                      </label>
                      <CommonSelect
                        placeholder="Supplier/Vendor/Agent Payment"
                        height={40}
                        options={[
                          {
                            value: "payment",
                            label: "Supplier/Vendor/Agent Payment",
                          },
                        ]}
                      />
                    </div>
                  </Col>
                </Row>
              </div>

              <button
                className="btn btn-light rounded-3 p-0 d-flex align-items-center justify-content-center"
                style={{
                  width: "36px",
                  height: "36px",
                  backgroundColor: "#FFE4E6",
                  color: "#E11D48",
                  border: "none",
                }}
                onClick={() => onRemoveReceiver(receiver.id)}
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Step2BulkPaymentInfo;
